module.exports = __webpack_public_path__ + "img/icon_box_1_2.a793cdab.png";